<template>
  <ButtonTooltip
    color="warning"
    icon="get_app"
    type="download"
    :tooltip="$t('adminVideo.buttons.downloadFile')"
    v-on:event-click="downloadFile"
    :disabled="disabled"
  />
</template>

<script>
import ButtonTooltip from '@/components/adminVideo/ButtonTooltip'

import downloadjs from 'downloadjs'
import { mapState } from 'vuex'

export default {
  name: 'ButtonTooltipDownload',

  components: {
    ButtonTooltip
  },

  props: ['indexName', 'disabled'],

  methods: {
    downloadFile() {
      if (!this.link) return
      downloadjs(this.link)
    }
  },

  computed: {
    ...mapState('adminVideo', {
      files: (state) => state.configurations[0]
    }),
    link() {
      if (this.indexName === 'introduction') return this.files.introductionVideoUrl
      if (this.indexName === 'conclusion') return this.files.conclusionVideoUrl
      if (this.indexName === 'audio') return this.files.audioUrl
      return false
    }
  }
}
</script>
